/**
 * Eden Treaty client for Lexicanon API.
 *
 * Provides a fully typed HTTP client derived from the backend's Elysia App type.
 * Uses credentials: "include" so Better Auth session cookies are sent automatically.
 *
 * `parseDate: false` disables Eden's default reviver that converts any string
 * matching `YYYY-MM-DD` / ISO-8601 / RFC date patterns into a `Date` object
 * during JSON.parse. Our analysis JSON treats fields like `action_points[].deadline`
 * as opaque strings (the LLM emits "vandaag", "EOD", "2025-05-15" interchangeably);
 * silently coercing the date-shaped subset to Date instances means components
 * like ActionItemsCard end up rendering `[object Date]` as a React child instead
 * of "2025-05-15", crashing the whole post-processed view via React #31.
 */

import { treaty } from "@elysiajs/eden"
import type { App } from "../../../../backend/src/index.ts"
import { reportFailedResponse } from "../client-error-reporting"
import { API_ORIGIN } from "../runtime-origin"

function reportEdenFailure(response: Response): void {
  if (response.ok || response.status === 401) return
  void response
    .clone()
    .json()
    .then((body: unknown) => {
      reportFailedResponse(response, body)
    })
    .catch(() => {
      reportFailedResponse(response)
    })
}

export const api = treaty<App>(API_ORIGIN, {
  fetch: { credentials: "include" },
  parseDate: false,
  onResponse: reportEdenFailure,
})
